import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ChevronLeftIcon, ChevronRightIcon, ExpandButtonWithSelect, IconButton } from '@tom-ui/ui'

interface Props {
  names: string[]
  selectedIndex: number
  label: string
  onChange: (index: number) => void
}

export const BlockHeaderNavigator = ({ names, selectedIndex, label, onChange }: Props) => {
  const { t } = useTranslate()

  const hasPrevious = selectedIndex > 1
  const hasNext = selectedIndex < names.length
  const displayName = names[selectedIndex - 1] ?? selectedIndex

  const options = names.map((name, i) => ({ label: name, value: i + 1 }))

  return (
    <Stack direction='row' alignItems='center' gap={0.5}>
      <Tooltip title={t('previous', 'Previous')}>
        <IconButton
          size='small'
          onClick={() => onChange(selectedIndex - 1)}
          disabled={!hasPrevious}
        >
          <ChevronLeftIcon fontSize='small' />
        </IconButton>
      </Tooltip>

      <Typography variant='subtitle1'>
        {label} {displayName}
      </Typography>

      <Tooltip title={t('next', 'Next')}>
        <IconButton size='small' onClick={() => onChange(selectedIndex + 1)} disabled={!hasNext}>
          <ChevronRightIcon fontSize='small' />
        </IconButton>
      </Tooltip>

      <ExpandButtonWithSelect
        tooltip={t('selectDimension', 'Select {label}', { label })}
        selectedOption={selectedIndex}
        options={options}
        onChange={option => onChange(+option.value)}
      />
    </Stack>
  )
}
